import { Permissions } from '../react/types/permissions';
import { useAngularService } from './get_angular_service';

const usePermissions = (): Permissions => {
  const EmploymentService = useAngularService('EmploymentService');
  const permissions = EmploymentService.get().permissions;

  return permissions;
};

export default usePermissions;
